import { Icon } from '@msc-b2c/shared-components';
import styles from './ShoppingCart.module.scss';
import { ShoppingCartProps } from '@msc-b2c/interfaces/types';
import { useSelector } from 'react-redux';
import { RootState } from '@msc-b2c/shared-utils';
import { navigateOrRedirectToRoute } from '../../navigationmenu/utils/navigationMenuUtils';
import { useNavigate } from 'react-router-dom';
import { getMergedCartDisplayItems } from '../../utils/myAreaCartUtils';

export function ShoppingCart({
  shoppingCartIcon,
  shoppingCartIconAriaLabel,
}: Readonly<ShoppingCartProps>) {
  const navigate = useNavigate();
  const { cartLink } = useSelector((state: RootState) => state.navigationMenuData);
  const { items: cart } = useSelector((state: RootState) => state.myAreaCart);
  const bookedServicesCount = getMergedCartDisplayItems(cart).length;
  const displayCount = bookedServicesCount > 9 ? '9+' : bookedServicesCount;
  const cartAccessibleLabel = shoppingCartIconAriaLabel?.trim();

  return (
    <button
      type="button"
      className={styles.shoppingCart}
      aria-label={cartAccessibleLabel}
      onClick={() => navigateOrRedirectToRoute(cartLink || {}, navigate)}
    >
      <Icon
        icon={shoppingCartIcon}
        ariaHidden={true}
        styleOption={styles.cartIcon}
      />
      {bookedServicesCount > 0 && (
        <span
          className={styles.badge}
          data-testid="cart-badge"
          aria-hidden="true"
        >
          {displayCount}
        </span>
      )}
    </button>
  );
}

export default ShoppingCart;
